import ActionButton from "antd/lib/modal/ActionButton";
import { MembersActionTypes, AppActionTypes, SignalRTypes } from "../actions";

const initState = {
  message: "",
  depositSuccessMessage: "",
  depositErrorMessage: "",
  depositLoading: false,
  withdrawSuccessMessage: "",
  withdrawErrorMessage: "",
  withdrawLoading: false,
  editDetailsErrorMessage: "",
  editDetailsSuccessMessage: "",
  betsMessage: null,
  loading: false,
  phoneValid: false,
  validateAccount: false,
  userData: "",
  newVoucher: "",
  balance: "",
  addPhoneCurrent: 0,
  transactions: [],
  totalTransactions: 0,
  forms: [],
  totalForms: 0,
  formDetails: "",
  voucherDetails: "",
  selectedCurrency: "",
  isGroup: false,
  betLines: null,
  openMobileTableDetails: false,
  openMobileVoucherDetails: false,
  betDetailsModalVisible: false,
  rewardSpinModal: false,
  voucherModalVisible: false,
  bonusConditions: null,
  addProviderListElements: [],
  MemberaddProviderListElements: [],
  isTipMeNumberValid: false,
  isTipMeNumberValidMessage: "",
  earlyCashouts: null,
  cashOutOfferLoading: false,
  cashOutOffer: null,
  cashOutOfferError: null,
  cashOutOfferMessage: null,
  earlyCashOutMessage: null,
  memberCashOutOffer: 0,
  memberCashOutString: null,
  formEvents: [],
  customVirtualSportUrl: null,
};
const member = (state = initState, action) => {
  switch (action.type) {
    case MembersActionTypes.Init:
      return {
        ...initState,
      };
    case MembersActionTypes.Set_Selected_Currency:
      return {
        ...state,
        selectedCurrency: action.currency,
        balance: action.currency.balance,
      };
    case MembersActionTypes.Add_Second_Member_Phone_Request:
      return {
        ...state,
        loading: true,
      };
    case MembersActionTypes.Add_Second_Member_Phone_Success:
      return {
        ...state,
        message: "",
        addPhoneCurrent: action.current,
        loading: false,
      };
    case MembersActionTypes.Add_Second_Member_Phone_Error:
      return {
        ...state,
        message: action.message,
        loading: false,
      };
    case MembersActionTypes.Validate_Add_Second_Phone_Request:
      return {
        ...state,
        loading: true,
      };
    case MembersActionTypes.Validate_Add_Second_Phone_Success:
      return {
        ...state,
        message: "",
        loading: false,
        phoneValid: true,
      };
    case MembersActionTypes.Validate_Add_Second_Phone_Error:
      return {
        ...state,
        message: action.message,
        loading: false,
      };
    case MembersActionTypes.Get_Member_Details_Success:
      return {
        ...state,
        userData: action.data,
      };
    case MembersActionTypes.Send_Verify_Email_Request:
      return {
        ...state,
        loading: true,
      };
    case MembersActionTypes.Send_Verify_Email_Success:
      return {
        ...state,
        loading: false,
        validateAccount: true,
      };
    case MembersActionTypes.Send_Verify_Email_Error:
      return {
        ...state,
        loading: false,
        editDetailsErrorMessage: action.message,
      };
    case MembersActionTypes.Member_Details_Request:
      return {
        ...state,
        loading: true,
      };
    case MembersActionTypes.Member_Details_Success:
      return {
        ...state,
        loading: false,
        editDetailsErrorMessage: "",
        editDetailsSuccessMessage: action.message,
      };
    case MembersActionTypes.Member_Details_Error:
      return {
        ...state,
        loading: false,
        editDetailsSuccessMessage: "",
        editDetailsErrorMessage: action.message,
      };

    case MembersActionTypes.Mtn_Withdraw_Success: {
      return {
        ...state,
        withdrawSuccessMessage: action.message,
        withdrawErrorMessage: null,
        withdrawLoading: false,
      };
    }
    case MembersActionTypes.Mtn_Withdraw_Request: {
      return {
        ...state,
        withdrawLoading: true,
      };
    }
    case MembersActionTypes.Mtn_Withdraw_Error: {
      return {
        ...state,
        withdrawErrorMessage: action.message,
        withdrawSuccessMessage: null,
        withdrawLoading: false,
      };
    }

    case MembersActionTypes.Tipme_Withdraw_Success: {
      return {
        ...state,
        withdrawSuccessMessage: action.message,
        withdrawErrorMessage: null,
        withdrawLoading: false,
      };
    }
    case MembersActionTypes.Tipme_Withdraw_Request: {
      return {
        ...state,
        withdrawLoading: true,
      };
    }
    case MembersActionTypes.Tipme_Withdraw_Error: {
      return {
        ...state,
        withdrawErrorMessage: action.message,
        withdrawSuccessMessage: null,
        withdrawLoading: false,
      };
    }

    case MembersActionTypes.Tipme_Confirm_Withdraw_Success: {
      return {
        ...state,
        withdrawSuccessMessage: action.message,
        isTipMeWithdrawConfirmed: true,
        withdrawErrorMessage: null,
        withdrawLoading: false,
      };
    }
    case MembersActionTypes.Tipme_Confirm_Withdraw_Request: {
      return {
        ...state,
        withdrawLoading: true,
      };
    }
    case MembersActionTypes.Tipme_Confirm_Withdraw_Error: {
      return {
        ...state,
        withdrawErrorMessage: action.message,
        isTipMeWithdrawConfirmed: false,
        withdrawSuccessMessage: null,
        withdrawLoading: false,
      };
    }

    case MembersActionTypes.Orange_Withdraw_Success: {
      return {
        ...state,
        withdrawSuccessMessage: action.message,
        withdrawErrorMessage: null,
        withdrawLoading: false,
      };
    }
    case MembersActionTypes.Orange_Withdraw_Request: {
      return {
        ...state,
        withdrawLoading: true,
      };
    }
    case MembersActionTypes.Orange_Withdraw_Error: {
      return {
        ...state,
        withdrawErrorMessage: action.message,
        withdrawSuccessMessage: null,
        withdrawLoading: false,
      };
    }
    case MembersActionTypes.Mtn_Deposit_Success: {
      return {
        ...state,
        depositSuccessMessage: action.message,
        depositErrorMessage: null,
        depositLoading: false,
      };
    }
    case MembersActionTypes.Mtn_Deposit_Request: {
      return {
        ...state,
        depositLoading: true,
      };
    }
    case MembersActionTypes.Mtn_Deposit_Error: {
      return {
        ...state,
        depositErrorMessage: action.message,
        depositSuccessMessage: null,
        depositLoading: false,
      };
    }
    case MembersActionTypes.Orange_Deposit_Success: {
      return {
        ...state,
        depositSuccessMessage: action.message,
        depositErrorMessage: null,
        depositLoading: false,
      };
    }
    case MembersActionTypes.Orange_Deposit_Request: {
      return {
        ...state,
        depositLoading: true,
      };
    }
    case MembersActionTypes.Orange_Deposit_Error: {
      return {
        ...state,
        depositErrorMessage: action.message,
        depositSuccessMessage: null,
        depositLoading: false,
      };
    }

    case MembersActionTypes.Deposit_From_Voucher_Success: {
      return {
        ...state,
        depositSuccessMessage: action.message,
        depositErrorMessage: null,
        balance: action.balance,
        depositLoading: false,
      };
    }
    case MembersActionTypes.Deposit_From_Voucher_Request: {
      return {
        ...state,
        depositLoading: true,
      };
    }
    case MembersActionTypes.Deposit_From_Voucher_Error: {
      return {
        ...state,
        depositErrorMessage: action.message,
        depositSuccessMessage: null,
        depositLoading: false,
      };
    }
    case MembersActionTypes.Withdrawal_To_Voucher_Request: {
      return {
        ...state,
        withdrawLoading: true,
        message: null,
        newVoucher: null,
      };
    }
    case MembersActionTypes.Withdrawal_To_Voucher_Success: {
      return {
        ...state,
        withdrawSuccessMessage: action.message,
        balance: action.balance,
        newVoucher: action.data.voucher,
        message: null,
        withdrawLoading: false,
      };
    }
    case MembersActionTypes.Withdrawal_To_Voucher_Error: {
      return {
        ...state,
        //withdrawErrorMessage: action.message,
        message: action.message,
        withdrawLoading: false,
      };
    }

    case MembersActionTypes.Member_Transactions_Request:
      return {
        ...state,
        transactions: [],
        totalTransactions: 0,
        loading: true,
      };

    case MembersActionTypes.Member_Transactions_Error:
      return {
        ...state,
        transactions: [],
        totalTransactions: 0,
        message: action.message,
        loading: false,
      };

    case MembersActionTypes.Member_Transactions_Success:
      return {
        ...state,
        transactions: action.transactions,
        totalTransactions: action.total,
        formDateRange: action.formDateRange,
        loading: false,
      };
    case MembersActionTypes.Member_Forms_Request:
      return {
        ...state,
        loading: true,
        betsMessage: null,
      };
    case MembersActionTypes.Member_Forms_Success:
      return {
        ...state,
        forms: action.forms,
        totalForms: action.total,
        formDateRange: action.formDateRange,
        formEvents: action.formEvents,
        loading: false,
      };

    case MembersActionTypes.Member_Forms_Change:
      return {
        ...state,
        forms: action.forms,
      };

    case MembersActionTypes.Member_Forms_Error:
      return {
        ...state,
        loading: false,
        betsMessage: action.message,
      };

    case MembersActionTypes.Voucher_Details_Request:
      return {
        ...state,
        loading: true,
      };
    case MembersActionTypes.Voucher_Details_Success:
      return {
        ...state,
        voucherDetails: action.voucherDetails,
        loading: false,
      };
    case MembersActionTypes.Voucher_Details_Error:
      return {
        ...state,
        loading: false,
      };

    case MembersActionTypes.Forms_Details_Request:
      return {
        ...state,
        loading: true,
        earlyCashouts: null,
      };
    case MembersActionTypes.Forms_Details_Success:
      return {
        ...state,
        formDetails: action.details,
        loading: false,
        isGroup: action.isGroup,
        betLines: action.betLines,
        earlyCashouts: action.earlyCashouts,
        formBonuses: action.formBonuses,
        isCustomBet: action.isCustomBet,
      };
    case MembersActionTypes.Add_Provider_List_Request:
      return {
        ...state,
        loading: true,
      };
    case MembersActionTypes.Add_Provider_List_Success:
      return {
        ...state,
        addProviderListElements: action.addProviderList,
      };
    case MembersActionTypes.Tip_Me_Customer_Search_Request:
      return {
        ...state,
        loading: true,
      };
    case MembersActionTypes.Tip_Me_Customer_Search_Success:
      return {
        ...state,
        isTipMeNumberValid: action.isTipMeNumberValid,
        isTipMeNumberValidMessage: action.isTipMeNumberValidMessage,
        tipMeCutomerSearchErrorMessage: false,
      };
    case MembersActionTypes.Tip_Me_Customer_Search_Error:
      return {
        ...state,
        loading: false,
        tipMeCutomerSearchErrorMessage: action.tipMeCutomerSearchErrorMessage,
      };

    case MembersActionTypes.Deposite_Tip_Me_Customer_Search_Request:
      return {
        ...state,
        loading: true,
      };
    case MembersActionTypes.Deposite_Tip_Me_Customer_Search_Success:
      return {
        ...state,
        depositeTipMeVertification: action.depositeTipMeVertification,
        depositeTipMeSuccessMessage: action.depositeTipMeSuccessMessage,
        depositeTipMeEstimateMessage: action.depositeTipMeEstimateMessage,
      };
    case MembersActionTypes.Deposite_Tip_Me_Customer_Search_Error:
      return {
        ...state,
        loading: false,
        depositeTipMeErrorMessage: action.depositeTipMeErrorMessage,
      };

    case MembersActionTypes.Tip_Me_OTP_Verification_Request:
      return {
        ...state,
        loading: true,
      };
    case MembersActionTypes.Tip_Me_OTP_Verification_Success:
      return {
        ...state,
        tipMeOTPVerificationSuccessMessage:
          action.tipMeOTPVerificationSuccessMessage,
        tipMeOTPErrormessage: action.tipMeOTPErrormessage,
      };
    case MembersActionTypes.Tip_Me_OTP_Verification_Error:
      return {
        ...state,
        loading: false,
        tipMeOTPErrormessage: action.tipMeOTPErrormessage,
      };

    case MembersActionTypes.Add_Member_Providers_Request:
      return {
        ...state,
        loading: true,
      };
    case MembersActionTypes.Add_Member_Providers_Success:
      return {
        ...state,
        addMemberProviderSuccessMessage: action.addMemberProviderSuccessMessage,
        addMemberProviderStatus: true,
      };
    case MembersActionTypes.Add_Member_Providers_Error:
      return {
        ...state,
        loading: false,
        addMemberProviderErrorMessage: action.addMemberProviderErrorMessage,
      };
    case MembersActionTypes.Create_Virtual_Sport_Token_Request:
      return {
        ...state,
        isVirtualSportTokenLoading: true,
      };
    case MembersActionTypes.Create_Virtual_Sport_Token_Success:
      return {
        ...state,
        isVirtualSportTokenLoading: false,
        virtualSportToken: action.virtualSportToken,
        virtualSportTokenData: action.virtualSportTokenData,
      };
    case MembersActionTypes.Create_Virtual_Sport_Token_Error:
      return {
        ...state,
        isVirtualSportTokenLoading: false,
        virtualSportTokenErrorMessage: action.virtualSportTokenErrorMessage,
      };

    case MembersActionTypes.Get_Virtuals_Sport_Menu_Request:
      return {
        ...state,
        isVirtualsSportMenuLoading: true,
      };
    case MembersActionTypes.Get_Virtuals_Sport_Menu_Success:
      return {
        ...state,
        isVirtualsSportMenuLoading: false,
        virtualsSportMenuData: action.virtualsSportMenuData,
      };
    case MembersActionTypes.Get_Virtuals_Sport_Menu_Error:
      return {
        ...state,
        isVirtualsSportMenuLoading: false,
        virtualsSportMenuErrorMessage: action.virtualsSportMenuErrorMessage,
      };

    case MembersActionTypes.Set_Virtual_Sport_Iframe_Url:
      return {
        ...state,
        virtualSportToken: action.url,
        customVirtualSportUrl: action.url,
      };

    case MembersActionTypes.Reset_Virtual_Sport_Iframe_Url:
      return {
        ...state,
        customVirtualSportUrl: null,
      };

    case MembersActionTypes.Get_Rewards_Request:
      return {
        ...state,
        loading: true,
      };
    case MembersActionTypes.Get_Rewards_Success:
      return {
        ...state,
        loading: false,
        rewardInfo: action.rewardInfo,
        rewardsTransactionButtonName: action.rewardsTransactionButtonName,
        currentLevelRewardsName: action.currentLevelRewardsName,
        rewardCurrentLevelList: action.rewardCurrentLevelList,
        nextLevelRewardsName: action.nextLevelRewardsName,
        rewardNextLevelList: action.rewardNextLevelList,
        howItWorksTitle: action.howItWorksTitle,
        howItWorksHeadMessage: action.howItWorksHeadMessage,
        howItWorksLines: action.howItWorksLines,
        rewardSystemTitle: action.rewardSystemTitle,
        rewardsSystems: action.rewardsSystems,
        slotsRewardList: action.slotsRewardList,
        slotsRewardsName: action.slotsRewardsName,
      };
    case MembersActionTypes.Get_Rewards_Error:
      return {
        ...state,
        loading: false,
        getRewardsErrorMessage: action.getRewardsErrorMessage,
      };

    case MembersActionTypes.Get_Rewards_Transaction_Request:
      return {
        ...state,
        loading: true,
      };
    case MembersActionTypes.Get_Rewards_Transaction_Success:
      return {
        ...state,
        loading: false,
        rewardsTransactionList: action.rewardsTransactionList,
        transactionsTotals: action.transactionsTotals,
      };
    case MembersActionTypes.Get_Rewards_Transaction_Error:
      return {
        ...state,
        loading: false,
        rewardsTransactionErrorMessage: action.rewardsTransactionErrorMessage,
      };

    case MembersActionTypes.Get_Club_Reward_Status_Request:
      return {
        ...state,
        loading: true,
      };
    case MembersActionTypes.Get_Club_Reward_Status_Success:
      return {
        ...state,
        loading: false,
        rewardClubStatus: action.rewardClubStatus,
        clubRewardStatusError: undefined,
      };
    case MembersActionTypes.Get_Club_Reward_Status_Error:
      return {
        ...state,
        loading: false,
        clubRewardStatusError: action.clubRewardStatusError,
      };

    case MembersActionTypes.Get_Club_Member_Reward_Info_Request:
      return {
        ...state,
        loading: true,
        rewardClubInfo: undefined,
        rewardClubInfoError: undefined,
      };
    case MembersActionTypes.Get_Club_Member_Reward_Info_Success:
      return {
        ...state,
        loading: false,
        rewardClubInfo: action.rewardClubInfo,
        rewardClubInfoError: undefined,
      };
    case MembersActionTypes.Get_Club_Member_Reward_Info_Error:
      return {
        ...state,
        loading: false,
        rewardClubInfoError: action.rewardClubInfoError,
      };

    case MembersActionTypes.Customer_Club_Reward_Redeem_Request:
      return {
        ...state,
        rewardRedeemLoading: true,
        rewardRedeemResponse: undefined,
        rewardRedeemError: undefined,
      };
    case MembersActionTypes.Customer_Club_Reward_Redeem_Success:
      return {
        ...state,
        rewardRedeemLoading: false,
        rewardRedeemResponse: action.rewardRedeemResponse,
        rewardRedeemError: undefined,
      };
    case MembersActionTypes.Customer_Club_Reward_Redeem_Error:
      return {
        ...state,
        rewardRedeemLoading: false,
        rewardRedeemError: action.rewardRedeemError,
      };

    case MembersActionTypes.Get_Wheel_Of_Fortune_Gift_Request:
      return {
        ...state,
        freeSpinLoading: true,
      };
    case MembersActionTypes.Get_Wheel_Of_Fortune_Gift_Success:
      return {
        ...state,
        freeSpinLoading: false,
        freeSpinGifts: action.freeSpinGifts,
        getFreeSpinGiftsError: undefined,
      };
    case MembersActionTypes.Get_Wheel_Of_Fortune_Gift_Error:
      return {
        ...state,
        freeSpinLoading: false,
        getFreeSpinGiftsError: action.getFreeSpinGiftsError,
      };

    case MembersActionTypes.Wheel_Of_Fortune_Spin_Request:
      return {
        ...state,
        wheelSpinLoading: true,
      };
    case MembersActionTypes.Wheel_Of_Fortune_Spin_Success:
      return {
        ...state,
        wheelSpinLoading: false,
        freeSpinResult: action.freeSpinResult,
        wheelSpinError: undefined,
      };
    case MembersActionTypes.Wheel_Of_Fortune_Spin_Error:
      return {
        ...state,
        wheelSpinLoading: false,
        wheelSpinError: action.wheelSpinError,
      };

    case MembersActionTypes.Tip_Me_First_Deposit_Message_Request:
      return {
        ...state,
        loading: true,
      };
    case MembersActionTypes.Tip_Me_First_Deposit_Message_Success:
      return {
        ...state,
        tipMeFirstDepositeMessage: action.tipMeFirstDepositeMessage,
      };
    case MembersActionTypes.Tip_Me_First_Deposit_Message_Error:
      return {
        ...state,
        loading: false,
        tipMeFirstDepositeMessageError: action.tipMeFirstDepositeMessageError,
      };

    case MembersActionTypes.Member_Add_Provider_List_Success:
      return {
        ...state,
        MemberaddProviderListElements: action.MemberaddProviderListElements,
      };
    case MembersActionTypes.Add_Provider_List_Error:
      return {
        ...state,
        loading: false,
        addProviderListErrorMessage: action.addProviderListErrorMessage,
      };
    case MembersActionTypes.Member_Add_Provider_List_Error:
      return {
        ...state,
        loading: false,
        MemberaddProviderListErrorMessage:
          action.MemberaddProviderListErrorMessage,
      };

    case MembersActionTypes.Forms_Details_Error:
      return {
        ...state,
        loading: false,
      };
    case MembersActionTypes.Member_Update_Balance:
      return {
        ...state,
        balance: action.balance,
      };
    case MembersActionTypes.Open_Mobile_Table_Details:
      return {
        ...state,
        openMobileTableDetails: action.open,
      };
    case MembersActionTypes.Open_Mobile_Voucher_Details:
      return {
        ...state,
        openMobileVoucherDetails: action.open,
      };
    case MembersActionTypes.Open_Bet_Details_Modal:
      return {
        ...state,
        betDetailsModalVisible: action.open,
      };
    case MembersActionTypes.Open_Reward_Spin_Modal:
      return {
        ...state,
        rewardSpinModal: action.open,
      };
    case MembersActionTypes.Open_Voucher_Modal:
      return {
        ...state,
        voucherModalVisible: action.open,
      };

    case MembersActionTypes.CheckDepositBonusConditions_Request:
      return {
        ...state,
        bonusConditions: null,
      };
    case MembersActionTypes.CheckDepositBonusConditions_Success:
      return {
        ...state,
        bonusConditions: action.conditions,
      };
    case MembersActionTypes.CheckDepositBonusConditions_Error:
      return {
        ...state,
        bonusConditions: null,
      };
    case MembersActionTypes.Get_Members_Games_Error:
      return {
        ...state,
        loading: false,
        getMembersGamesErrorMessage: action.getMembersGamesErrorMessage,
      };

    case MembersActionTypes.Get_Member_Balance_Request:
      return {
        ...state,
        loading: true,
        getMemberBalanceErrorMessage: null,
      };

    case MembersActionTypes.Get_Member_Balance_Success:
      return {
        ...state,
        loading: false,
        memberBalanceData: action.data,
      };

    case MembersActionTypes.Get_Member_Balance_Error:
      return {
        ...state,
        loading: false,
        getMemberBalanceErrorMessage: action.message,
      };

    case SignalRTypes.Member_Change_Update_Balance:
      return {
        ...state,
        balance: action.balance,
        balanceStatus: action.balanceStatus,
      };
    case MembersActionTypes.CreateCustomerServiceCode_Request:
      return {
        ...state,
        customerServiceCode: null,
        customerServiceCodeExpiresMinutes: null,
        customerServiceMessege: null,
        customerServiceLoading: true,
      };
    case MembersActionTypes.CreateCustomerServiceCode_Success:
      return {
        ...state,
        customerServiceCode: action.customerServiceCode,
        customerServiceCodeExpiresMinutes: action.dateTimeExpire,
        customerServiceMessege: null,
        customerServiceLoading: false,
      };
    case MembersActionTypes.CreateCustomerServiceCode_Error:
      return {
        ...state,
        customerServiceCode: null,
        customerServiceCodeExpiresMinutes: null,
        customerServiceMessege: action.message,
        customerServiceLoading: false,
      };

    case MembersActionTypes.Get_Loyalty_Rewards_Coupons_Request:
      return {
        ...state,
        loadingLoyaltyCoupons: true,
      };
    case MembersActionTypes.Get_Loyalty_Rewards_Coupons_Success:
      return {
        ...state,
        loadingLoyaltyCoupons: false,
        loyaltyCoupons: action.loyaltyCoupons,
        loyaltyCouponsError: undefined,
      };
    case MembersActionTypes.Get_Loyalty_Rewards_Coupons_Error:
      return {
        ...state,
        loadingLoyaltyCoupons: false,
        loyaltyCoupons: undefined,
        loyaltyCouponsError: action.loyaltyCouponsError,
      };

    case MembersActionTypes.Create_Member_Slots_Bonus_Request:
      return {
        ...state,
        loadingCreateMemberSlots: true,
        createMemberSlotsInfo: undefined,
        createMemberSlotsError: undefined,
      };
    case MembersActionTypes.Create_Member_Slots_Bonus_Success:
      return {
        ...state,
        loadingCreateMemberSlots: false,
        createMemberSlotsInfo: action.createMemberSlotsInfo,
        createMemberSlotsError: undefined,
      };
    case MembersActionTypes.Create_Member_Slots_Bonus_Error:
      return {
        ...state,
        loadingCreateMemberSlots: false,
        createMemberSlotsInfo: undefined,
        createMemberSlotsError: action.createMemberSlotsError,
      };

    case MembersActionTypes.Reset_Single_Reward:
      return {
        ...state,
        loadingCreateMemberSlots: undefined,
        createMemberSlotsInfo: undefined,
        createMemberSlotsError: undefined,
        loading: undefined,
        rewardClubInfo: undefined,
        rewardClubInfoError: undefined,
        rewardRedeemLoading: undefined,
        rewardRedeemResponse: undefined,
        rewardRedeemError: undefined,
      };
    case MembersActionTypes.Get_Last_Reward_Notifications_Request:
      return {
        ...state,
        rewardNotifications: undefined,
        rewardNotificationError: undefined,
        loadingRewardNotification: true,
      };
    case MembersActionTypes.Get_Last_Reward_Notifications_Success:
      return {
        ...state,
        rewardNotifications: action.rewardNotifications,
        rewardNotificationError: undefined,
        loadingRewardNotification: false,
      };

    case MembersActionTypes.Get_Last_Reward_Notifications_Error:
      return {
        ...state,
        rewardNotifications: undefined,
        rewardNotificationError: action.rewardNotificationError,
        loadingRewardNotification: false,
      };

    case MembersActionTypes.Get_Notification_History_Request:
      return {
        ...state,
        notficationHistory: undefined,
        notficationHistoryError: undefined,
        loadingNotficationHistory: true,
      };
    case MembersActionTypes.Get_Notification_History_Success:
      return {
        ...state,
        notficationHistory: action.notficationHistory,
        notficationHistoryError: undefined,
        loadingNotficationHistory: false,
      };

    case MembersActionTypes.Get_Notification_History_Error:
      return {
        ...state,
        notficationHistory: undefined,
        notficationHistoryError: action.notficationHistoryError,
        loadingNotficationHistory: false,
      };
    case MembersActionTypes.Delete_Notification_Request:
      return {
        ...state,
        notificationDeleted: false,
        deleteNotificationError: undefined,
      };
    case MembersActionTypes.Delete_Notification_Success:
      return {
        ...state,
        notificationDeleted: true,
        deleteNotificationError: undefined,
      };

    case MembersActionTypes.Delete_Notification_Error:
      return {
        ...state,
        notificationDeleted: false,
        deleteNotificationError: action.deleteNotificationError,
      };
    case MembersActionTypes.Get_Notification_Count_Request:
      return {
        ...state,
        notificationCount: undefined,
        getNotificationError: undefined,
      };
    case MembersActionTypes.Get_Notification_Count_Success:
      return {
        ...state,
        notificationCount: action.notificationCount,
      };

    case MembersActionTypes.Get_Notification_Count_Error:
      return {
        ...state,
        notificationCount: undefined,
        getNotificationError: action.getNotificationError,
      };

    case MembersActionTypes.Mute_Notification_Request:
      return {
        ...state,
      };
    case MembersActionTypes.Mute_Notification_Success:
      return {
        ...state,
        muteNofification: action.muteNofification,
      };

    case MembersActionTypes.Mute_Notification_Error:
      return {
        ...state,
        muteNofificationError: action.muteNofificationError,
      };

    case MembersActionTypes.Get_Form_Cash_Out_Offer_Request:
      return {
        ...state,
        cashOutOfferLoading: true,
        cashOutOfferMessage: null,
        cashOutOfferError: null,
      };
    case MembersActionTypes.Get_Form_Cash_Out_Offer_Success:
      return {
        ...state,
        cashOutOfferLoading: false,
        cashOutOffer: action.cashOutOffer,
        cashOutOfferMessage: action.message,
        cashOutOfferError: null,
      };
    case MembersActionTypes.Get_Form_Cash_Out_Offer_Error:
      return {
        ...state,
        cashOutOfferLoading: false,
        cashOutOfferMessage: null,
        cashOutOfferError: action.cashOutOfferError,
      };

    case MembersActionTypes.Early_Cash_Out_Request:
      return {
        ...state,
        cashOutOfferLoading: true,
        earlyCashOutMessage: null,
        cashOutOfferError: null,
      };
    case MembersActionTypes.Early_Cash_Out_Success:
      return {
        ...state,
        cashOutOfferLoading: false,
        earlyCashOutMessage: action.message,
        cashOutOffer: null,
        cashOutOfferError: null,
      };
    case MembersActionTypes.Early_Cash_Out_Error:
      return {
        ...state,
        cashOutOfferLoading: false,
        earlyCashOutMessage: null,
        cashOutOfferError: action.cashOutOfferError,
      };
    case MembersActionTypes.Set_Member_Cash_Out_Offer:
      return {
        ...state,
        memberCashOutOffer: action.data.memberCashOutOffer,
        memberCashOutOfferCurrency: action.data.memberCashOutOfferCurrency,
      };
    case MembersActionTypes.Reset_Member_Cash_Out_Offer:
      return {
        ...state,
        cashOutOfferError: null,
        earlyCashOutMessage: null,
        cashOutOffer: null,
        memberCashOutOffer: 0,
      };

    case MembersActionTypes.Get_Notification_Details_Request:
      return {
        ...state,
        notificationDetails: undefined,
        notificationDetailsLoading: true,
        notificationDetailsError: undefined,
      };
    case MembersActionTypes.Get_Notification_Details_Success:
      return {
        ...state,
        notificationDetails: action.notificationDetails,
        notificationDetailsLoading: false,
      };

    case MembersActionTypes.Get_Notification_Details_Error:
      return {
        ...state,
        notificationDetails: undefined,
        notificationDetailsLoading: false,
        notificationDetailsError: action.notificationDetailsError,
      };
    case MembersActionTypes.Read_Notification_Status_Request:
      return {
        ...state,
      };
    case MembersActionTypes.Read_Notification_Status_Success:
      return {
        ...state,
        ReadNotificationStatus: true,
      };

    case MembersActionTypes.Read_Notification_Status_Error:
      return {
        ...state,
        ReadNotificationStatusError: action.ReadNotificationStatusError,
      };
    case MembersActionTypes.Manage_Memeber_Favorite_Request:
      return {
        ...state,
        favoriteAdded: undefined,
      };
    case MembersActionTypes.Manage_Memeber_Favorite_Success:
      return {
        ...state,
        favoriteAdded: true,
      };

    case MembersActionTypes.Manage_Memeber_Favorite_Error:
      return {
        ...state,
        favoriteAdded: false,
      };
    case MembersActionTypes.Create_Member_Slots_Bonus_By_Coupon_Code_Request:
      return {
        ...state,
        loadingCreateMemberSlotsBonus: true,
      };
    case MembersActionTypes.Create_Member_Slots_Bonus_By_Coupon_Code_Success:
      return {
        ...state,
        loadingCreateMemberSlotsBonus: false,
        successCreateMemberSlotsBonus: true,
        errorCreateMemberSlotsBonus: undefined,
      };
    case MembersActionTypes.Create_Member_Slots_Bonus_By_Coupon_Code_Error:
      return {
        ...state,
        loadingCreateMemberSlotsBonus: false,
        successCreateMemberSlotsBonus: undefined,
        errorCreateMemberSlotsBonus: action.message,
      };

    default:
      return state;
  }
};

export default member;
